export default {
  title: 'Layer Management',
  name: 'Name',
  actions: 'Actions:',
  cancel: 'Cancel',
  accept: 'Accept',
  activate: 'Activate layer',
  deactivate: 'Deactivate layer',
  sourceInfo: 'Source Information',
  source: 'Source',
  layer: 'Layer',
  theme: 'Theme',
  opacityLevel: 'Opacity: {percentage}%',
  currentOpacity: 'Opacity: {percentage}%'
}
